import SText from "@/styles/SText";
import { BarcodeDiff } from "@/types/inventoryV2";
import { Button, Empty, List, Modal, Table, Tabs } from "antd";
import React from "react";
import { FC } from "react";
import { useTranslation } from "react-i18next";

interface BarcodeDiffModalProps {
  open: boolean;
  onClose: () => void;
  barcodeDiffs: BarcodeDiff[];
  productCode: string;
  lotStr: string;
}
const BarcodeDiffModal: FC<BarcodeDiffModalProps> = ({ open, onClose, barcodeDiffs }) => {
  const { t } = useTranslation();

  const { diffCodes, bothExist } = React.useMemo(() => {
    const bothExist: string[] = [];
    const diffCodes: Array<BarcodeDiff> = [];

    barcodeDiffs.forEach(diff => {
      if (diff.locationBarcode && diff.countingBarcode) {
        if (diff.locationBarcode === diff.countingBarcode) {
          bothExist.push(diff.locationBarcode);
        }
      } else {
        diffCodes.push(diff);
      }
    });

    return { diffCodes, bothExist };
  }, [barcodeDiffs]);

  const renderBarcodeList = (barcodes: string[]) => {
    if (barcodes.length === 0) {
      return <Empty />;
    }
    return (
      <List
        dataSource={barcodes}
        renderItem={(barcode) => (
          <List.Item style={{ padding: '8px 12px', borderBottom: '1px solid #f0f0f0' }}>
            <SText text={barcode} />
          </List.Item>
        )}
        style={{ maxHeight: '400px', overflow: 'auto' }}
      />
    );
  };

  const items = [
    {
      key: '1',
      label: `${t('counting.diffCodes')} (${diffCodes.length})`,
      children: (
        <Table<BarcodeDiff>
          columns={[
            { title: t('counting.countingCodes'), dataIndex: "countingBarcode" },
            { title: t('counting.system'), dataIndex: "locationBarcode" },
          ]}
          dataSource={diffCodes}
          pagination={false}
        />
      ),
    },
    {
      key: '2',
      label: `${t('counting.normalCodes')} (${bothExist.length})`,
      children: renderBarcodeList(bothExist),
    },
  ];

  return (
    <Modal
      title={t('counting.barcodeDiff')}
      open={open}
      onCancel={onClose}
      footer={[
        <Button key="close" onClick={onClose}>
          {t('requirement.close')}
        </Button>,
      ]}
      width={800}
    >
      <Tabs type="card"
        defaultActiveKey="1"
        items={items}
        tabBarStyle={{ marginBottom: '16px' }}
      />
    </Modal>
  );
};

export default BarcodeDiffModal;